import { Container, TopBar, Main, BodyContainer } from "./styled";
import { MyAccount } from "../SubscriptionsPage/components";

export const PageContainer = ({ title, children }) => {
  return (
    <Container>
      <TopBar>
        <h1>{title}</h1>
      </TopBar>
      <Main>
        <MyAccount />
        <BodyContainer>{children}</BodyContainer>
      </Main>
    </Container>
  );
};
